import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Flame, CalendarCheck, ChevronRight } from "lucide-react";
import { dailyApi, getToken } from "../lib/api";
import { buildDaily } from "../data/dailyClash";

export const untilReset = (ts) => {
  const s = Math.max(0, ts - Date.now() / 1000);
  const h = Math.floor(s / 3600);
  return h ? `${h}h ${Math.floor((s % 3600) / 60)}m` : `${Math.max(1, Math.floor(s / 60))}m`;
};

// Slim Home card: today's Daily Clash, streak flame and reward.
const DailyClashCard = ({ userKey, onOpen }) => {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => {
    if (getToken()) dailyApi.get().then(setD).catch(() => {});
  }, [userKey]);
  const theme = useMemo(() => (d ? buildDaily(d.seed).theme : null), [d]);

  return (
    <button data-testid="daily-clash-card" onClick={() => (onOpen ? onOpen() : navigate("/daily"))}
      className="mt-6 w-full flex items-center gap-3 rounded-xl border border-[#334155] border-l-4 border-l-[#F59E0B] bg-[#1E293B] px-4 py-3 text-left transition-colors hover:bg-[#233044] fade-up">
      <span className="relative w-10 h-10 rounded-lg bg-[#0F172A] flex items-center justify-center shrink-0">
        {d?.played ? <CalendarCheck className="w-5 h-5 text-[#F59E0B]" /> : <Flame className="w-5 h-5 text-[#F59E0B]" />}
      </span>
      <span className="flex-1 min-w-0">
        <span className="block font-display font-bold uppercase tracking-wide text-base leading-tight">
          Daily Clash{theme ? <span className="text-slate-300 font-semibold"> · Pep's {theme.club}</span> : null}
        </span>
        <span data-testid="daily-clash-sub" className="block text-[11px] text-slate-400 truncate">
          {d?.played ? `Done for today · new clash in ${untilReset(d.next_reset)}` : `Draft 3, beat Pep, win £${d?.reward_win ?? 15}`}
        </span>
      </span>
      <span data-testid="daily-streak" className="flex items-center gap-1 rounded-md bg-[#0F172A] px-2 py-1 text-sm font-display font-extrabold text-[#F59E0B] tabular shrink-0">
        <Flame className="w-3.5 h-3.5" /> {d?.streak ?? 0}
      </span>
      <ChevronRight className="w-4 h-4 text-[#F59E0B] shrink-0" />
    </button>
  );
};

export default DailyClashCard;
